import { createAction, props } from '@ngrx/store';
export const setChartOption = createAction('[Scatter Plot] Set Chart Option', props());
export const setNameInLegend = createAction('[Scatter Plot] Set Name In Legend', props());
